import API from '../../../../../services/api';

export const TARIFAS_VALOR_API = {
    new: async (valor) => {
        return API.post('/tarifas-valores', valor).then(res => res.data);
    },
    update: async (valor) => {
        return API.put('/tarifas-valores/' + valor.id, valor).then(res => res.data);
    },
    delete: async (idValor) => {
        return API.delete('/tarifas-valores/' + idValor).then(res => res.data);
    }
}